import { Button, TableColumnsType } from 'antd'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { Text } from 'src/components'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { PatientQuizState } from './PatientQuizState'

export const useConfig = () => {
  const { t, currentLang } = useLocales()

  const navigate = useNavigate()

  const columns = useMemo(
    (): TableColumnsType => [
      {
        key: 'title',
        title: t('classifiers.title'),
        width: '60%',
        render: ({ name }) => <Text>{name?.[currentLang?.value]}</Text>
      },
      {
        key: 'questionsCount',
        title: t('questionnaires.questions_count'),
        dataIndex: 'questionsCount',
        width: '20%'
      },
      {
        key: 'status',
        title: t('form.status'),
        width: '10%',
        render: ({ isAnswered }) => {
          return <PatientQuizState status={isAnswered} />
        }
      },
      {
        key: 'actions',
        render: ({ id, isAnswered }) => (
          <Button
            type="link"
            onClick={() =>
              navigate(
                isAnswered
                  ? paths.patients.quiz.quizDetails(id)
                  : paths.patients.quiz.complete(id)
              )
            }
          >
            {t('common.see_details')}
          </Button>
        )
      }
    ],
    [t]
  )

  return { columns }
}
